var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Newsletter = (function (Newsletter) {

        Newsletter.Messages = (function (Messages) {

            Messages.Subscribe = function (email, subscriptionType, gender, mailparams, mailLists, apiKey, username, checkOnly) {
                var data = {
                    email: email,
                    subscriptionType: subscriptionType, 
                    apiKey: apiKey || null,
                    mailparams: mailparams || {},
                    mailLists: mailLists,
                    gender: gender || null,
                    username: username || null,
                    checkOnly: checkOnly || false
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Newsletter.Messages.Subscribe", data);
            };
            Messages.Subscribe.className = "Vendd.Newsletter.Messages.Subscribe";

            Messages.SubscribeSuccess = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Newsletter.Messages.SubscribeSuccess", response);
            };
            Messages.SubscribeSuccess.className = "Vendd.Newsletter.Messages.SubscribeSuccess";

            Messages.SubscribeFailure = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Newsletter.Messages.SubscribeFailure", response);
            };
            Messages.SubscribeFailure.className = "Vendd.Newsletter.Messages.SubscribeFailure";

            Messages.Unsubscribe = function (apiKey) {
                var data = {
                    apiKey: apiKey
                };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Newsletter.Messages.Unsubscribe", data);
            };
            Messages.Unsubscribe.className = "Vendd.Newsletter.Messages.Unsubscribe";

            Messages.UnsubscribeSuccess = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Newsletter.Messages.UnsubscribeSuccess", response);
            };
            Messages.UnsubscribeSuccess.className = "Vendd.Newsletter.Messages.UnsubscribeSuccess";

            Messages.UnsubscribeFailure = function (response) {
                response.data = JSON.parse(response.data);

                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Newsletter.Messages.UnsubscribeFailure", response);
            };
            Messages.UnsubscribeFailure.className = "Vendd.Newsletter.Messages.UnsubscribeFailure";

            Messages.UpdateNewLetterVariables = function (source, apikey) {

                var data = { source: source, apikey: apikey };
                Vendd.MessageBus.VenddMessage.call(this, "Vendd.Newsletter.Messages.UpdateNewLetterVariables", data);
            }
            Messages.UpdateNewLetterVariables.className = "Vendd.Newsletter.Messages.UpdateNewLetterVariables";


            return Messages;

        })(Newsletter.Messages || {});

        return Newsletter;

        })(Vendd.Newsletter || {});

    return Vendd;

    })(Vendd || {});